import { TaskRow } from './types';
import { TaskNode } from '@/api/REST/projects';

export const flattenTasks = (
  nodes: TaskNode[],
  parentPath: string[] = [],
): TaskRow[] => {
  return nodes.flatMap(({ task, children }) => {
    const path = [...parentPath, task.wbs];
    const row: TaskRow = {
      ...task,
      id: task.taskId,
      path,
      __reorder__: task.name,
    };
    return [row, ...flattenTasks(children, path)];
  });
};
